import _jsx from "@babel/runtime/helpers/jsx";

var _ProductsFiltersForm;

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { META_FOR_RKO_PAGE, META_FOR_FOP_PAGE, META_FOR_IT_PAGE, PRODUCT_TYPES, CLIENT_TYPES } from 'constants/index';
import { useSeoMeta, useWebPageSchema, useMetaPage, useSelectorProps } from 'hooks';
import { getCompaniesWithProducts, getUpdatedDate } from 'selectors';
import PageHelmet from 'components/PageHelmet';
import PageInner from 'components/PageInner';
import LayoutContainer from 'components/LayoutContainer';
import ProductsFiltersForm from 'components/ProductsFiltersForm';
import UpdatedInfo from 'components/UpdatedInfo';
import { Wrapper, Title, Description, HeaderText, WrapperContainer } from './styles';

var HomePageHeader = function HomePageHeader(_ref) {
  var params = _ref.match.params;
  var selectorProps = useSelectorProps();
  var organizationsWithProducts = useSelector(function (state) {
    return getCompaniesWithProducts(state, selectorProps);
  });
  var clientType = params.clientType,
      page = params.page;
  var updated = useSelector(function (state) {
    return getUpdatedDate(state, selectorProps);
  });

  var _useIntl = useIntl(),
      locale = _useIntl.locale;

  var currentLocale = locale === 'ru' ? '' : '/ua';
  var isFopPage = page === PRODUCT_TYPES.fop;
  var isItPage = clientType === CLIENT_TYPES.it;
  var seoParams = isItPage && META_FOR_IT_PAGE || isFopPage && META_FOR_FOP_PAGE || META_FOR_RKO_PAGE;

  var _useSeoMeta = useSeoMeta(seoParams),
      pageTitle = _useSeoMeta.pageTitle,
      pageDescription = _useSeoMeta.pageDescription,
      metaTitle = _useSeoMeta.metaTitle,
      metaDescription = _useSeoMeta.metaDescription;

  var meta = useMetaPage();
  var pageSchema = useWebPageSchema({
    '@type': 'ItemList',
    name: pageTitle,
    itemListElement: organizationsWithProducts.slice(0, 5).map(function (el) {
      return {
        '@context': 'https://schema.org/',
        '@type': 'BankAccount',
        name: el.products[0].productName,
        provider: {
          '@type': 'BankOrCreditUnion',
          name: el.slug
        },
        feesAndCommissionsSpecification: "".concat(process.env.APP_MINFIN_DOMAIN).concat(currentLocale).concat(process.env.APP_ROUTER_BASENAME, "/").concat(el.slug, "/")
      };
    })
  }, metaTitle, metaDescription);
  var pageScripts = useMemo(function () {
    return [{
      type: 'application/ld+json',
      innerHTML: pageSchema
    }];
  }, [pageSchema]);
  return /*#__PURE__*/_jsx(Wrapper, {}, void 0, /*#__PURE__*/_jsx(LayoutContainer, {}, void 0, /*#__PURE__*/_jsx(PageHelmet, {
    pageTitle: pageTitle,
    metaTitle: metaTitle,
    metaDescription: metaDescription,
    meta: meta,
    script: pageScripts
  }), /*#__PURE__*/_jsx(PageInner, {}, void 0, /*#__PURE__*/_jsx(WrapperContainer, {}, void 0, /*#__PURE__*/_jsx(UpdatedInfo, {
    updated: updated
  }), /*#__PURE__*/_jsx(HeaderText, {}, void 0, /*#__PURE__*/_jsx(Title, {}, void 0, pageTitle), /*#__PURE__*/_jsx(Description, {}, void 0, pageDescription)), _ProductsFiltersForm || (_ProductsFiltersForm = /*#__PURE__*/_jsx(ProductsFiltersForm, {}))))));
};

export default withRouter(HomePageHeader);